import {
    Box,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Pagination,
    Tooltip,
    Typography,
    Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import api from "../../../../../Apis";
import { useParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
// import ChatIcon from "@mui/icons-material/Chat";
import AddIcon from '@mui/icons-material/Add';
import TrainingBotAIDialog from "./TrainingBotAIDialog";



const TrainingHistorySidebar = ({ is_login }) => {
    const { t } = useTranslation();
    const { fanpage_id, ai_id } = useParams();
    
    const [state, setState] = useState({
        trainingHistory: [],
        trainingTotalPage: 1,
        trainingCurrentPage: 1,
        trainingLoading: false,
    });
    const [totalPrice, setTotalPrice] = useState(0);
    const [isOpenTrainDialog, setIsOpenTrainDialog] = useState(false);

    // Fetch training history
    const fetchTrainingHistory = async (page = 1) => {
        setState((prevState) => ({ ...prevState, trainingLoading: true }));

        try {
            const res = await fetch(
                `${api.gpt_assistant_training_history}?page=${page}&ai_bot_id=${ai_id}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${is_login}`,
                    },
                }
            );
            const data = await res.json();

            if (data?.success) {
                setState((prevState) => ({
                    ...prevState,
                    trainingHistory: data?.data || [],
                    trainingTotalPage: data?.total_page || 1,
                    trainingLoading: false,
                }));
            } else {
                throw new Error(data?.message);
            }
        } catch (error) {
            console.log(error);
            setState((prevState) => ({ ...prevState, trainingLoading: false }));
        }
    };

    const handleTrainingPageChange = (event, value) => {
        setState((prevState) => ({ ...prevState, trainingCurrentPage: value }));
        fetchTrainingHistory(value);
    };
      const handleDeleteHistory = (id) => {
        Swal.fire({
          title: "Bạn có chắc chắn muốn xóa lịch sử huấn luyện này?",
          text: "Hành động này không thể hoàn tác!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Xóa",
          cancelButtonText: "Hủy",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              setState((prevState) => ({ ...prevState, trainingLoading: true }));
              const res = await fetch(
                `${api.gpt_assistant_training_delete}?vector_id=${id}`,
                {
                  method: "DELETE",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${is_login}`,
                  },
                }
              );
              const data = await res.json();
              if (data?.success) {
                Swal.fire(
                  "Đã xóa!",
                  data?.message || "Lịch sử huấn luyện đã được xóa.",
                  "success"
                );
                // Cập nhật lại danh sách sau khi xóa
                setState((prevState) => ({
                  ...prevState,
                  trainingHistory: prevState.trainingHistory.filter(
                    (item) => item.id !== id
                  ),
                }));
              } else {
                throw new Error(data?.message);
              }
            } catch (error) {
              console.log(error);
              Swal.fire(
                "Lỗi!",
                error?.message || "Đã có lỗi xảy ra khi xóa lịch sử.",
                "error"
              );
            } finally {
                setState((prevState) => ({ ...prevState, trainingLoading: false }));
            }
          }
        });
      };

    useEffect(() => {
        if (is_login) {
            fetchTrainingHistory(1);
        }
    }, [is_login]);

    useEffect(() => {
        (async () => {
          const requestOptions = {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${is_login}`,
            },
          };
          fetch(`${api.gpt_assistant_get_total_price}?ai_bot_id=${ai_id}`, requestOptions)
            .then((res) => res.json())
            .then((result) => {
              if (result.success) {
                setTotalPrice(result?.total_price || 0);
              }else {
                Swal.fire(
                  result?.message || t("common.message.pleaseTryAgain"),
                  "",
                  "error"
                );
              }
            })
            .catch((error) => {
              Swal.fire(
                error?.message || t("common.message.pleaseTryAgain"),
                "",
                "error"
              );
            });
        })();
      }, [is_login, ai_id, t]);

    return (
        <Box sx={{ pl:1, pt: 2 }}>
            <Box sx={{ mb:2}}>
                <Button
                    variant="contained"
                    color="primary"
                    sx={{ textTransform: "none" }}
                    onClick={() => setIsOpenTrainDialog(true)}
                    startIcon={<AddIcon />}
                    size="small"
                >
                   Huấn luyện Bot AI
                </Button>
            </Box>
            <Box
                sx={{
                    mb: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                {/* <h3 style={{ margin: 0 }}>Dữ liệu dạy AI của bạn</h3> */}
                <Box>
                    <Typography
                        variant="h6"
                        sx={{
                        mt: 1,
                        }}
                    >
                        Tổng chi phí: {totalPrice.toLocaleString()} VNĐ
                    </Typography>
                </Box>
                {state.trainingTotalPage > 1 && (
                    <Pagination
                        count={state.trainingTotalPage}
                        page={state.trainingCurrentPage}
                        onChange={handleTrainingPageChange}
                        color="primary"
                        size="small"
                        showFirstButton
                        showLastButton
                    />
                )}
            </Box>

            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ width: 40, fontWeight: "bold", textAlign: "center" }}>STT</TableCell>
                            <TableCell sx={{ fontWeight: "bold" }}>Nội dung</TableCell>
                            <TableCell>Tổng chi phí</TableCell>
                            <TableCell >Thao tác</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {state.trainingLoading ? (
                            <TableRow>
                                <TableCell colSpan={4} align="center" sx={{ py: 5 }}>
                                    <CircularProgress />
                                </TableCell>
                            </TableRow>
                        ) : state.trainingHistory.length > 0 ? (
                            state.trainingHistory.map((item, index) => (
                                <TableRow key={item.id}>
                                    <TableCell sx={{ textAlign: "center" }}>
                                        {(state.trainingCurrentPage - 1) * 10 + index + 1}
                                    </TableCell>
                                    <TableCell
                                        sx={{
                                            whiteSpace: "pre-wrap",
                                            wordBreak: "break-word",
                                            maxWidth: 400,
                                        }}
                                    >
                                        {item.chunk_text}
                                    </TableCell>
                                    <TableCell>
                                        {Number(item.total_price).toLocaleString()} VNĐ
                                    </TableCell>
                                    <TableCell align="center">
                                        <Tooltip
                                            title="Xóa lịch sử huấn luyện"
                                            arrow
                                            placement="top"
                                        >
                                            <DeleteIcon
                                            color="error"
                                            sx={{ cursor: "pointer" }}
                                            onClick={() => handleDeleteHistory(item.id)}
                                            />
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    Không có dữ liệu
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>

            {state.trainingTotalPage > 1 && (
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                    <Pagination
                        count={state.trainingTotalPage}
                        page={state.trainingCurrentPage}
                        onChange={handleTrainingPageChange}
                        color="primary"
                        showFirstButton
                        showLastButton
                        size="small"
                    />
                </Box>
            )}
            <TrainingBotAIDialog
                isOpen={isOpenTrainDialog}
                onClose={() => setIsOpenTrainDialog(false)}
                fetchTrainingHistory={fetchTrainingHistory}
            />
        </Box>
    );
};

export default TrainingHistorySidebar;
